// extracted by mini-css-extract-plugin
export default {"like":"_2BArA","not-clickable":"N2qhe","notClickable":"N2qhe","likebutton":"rhmij","likes":"Ybdf6"};